import React from 'react'

import * as Styled from './styled'

interface SupportSelectProps {
  label: string
  onSelect?: () => void
  isChecked?: boolean
  className?: string
}

const SupportSelect: React.FC<SupportSelectProps> = ({ label, onSelect, isChecked }) => {
  return (
    <Styled.SelectContainer onClick={onSelect} $isChecked={isChecked}>
      {label}
      <input type="radio" name="support-group" defaultChecked={isChecked} />
      <span>
        <span />
      </span>
    </Styled.SelectContainer>
  )
}

export default SupportSelect
